<template>
  <div class="mypage-header">
    <div class="inner">
      <h3>{{ $i18nUtil.trans("title.PrivateHeader.001","프라이빗") }} <span>{{ $i18nUtil.trans("message.PrivateHeader.001","나만의 공간을 자유롭게 활용하고 멤버를 초대하여 자료를 공유해보세요.") }}</span></h3>
      <button type="button" class="btn-primary-smaller black board-add" @click="addBoard">
        {{ $i18nUtil.trans("button.paper.user.add","프라이빗 보드 추가") }}
      </button>
      <!-- <div class="storage">
        <div class="total">
          <div
            class="usage"
            :style="{
              width:
                (groupInfo.currentSpaceSize /
                  1024 /
                  1024 /
                  1024 /
                  (groupInfo.spaceSize / 1024)) *
                  100 +
                'px',
            }"
          ></div>
        </div>
        <div class="usage-txt">
          {{ (groupInfo.currentSpaceSize / 1024 / 1024 / 1024).toFixed(4) }}GB
        </div>
        <div class="totoal-txt">/{{ groupInfo.spaceSize / 1024 }}GB</div>
        <dl class="layer-detail_info_view">
          <dt>
            <button
              type="button"
              @click="$event.target.parentElement.classList.toggle('active')"
            >
              세부정보보기
            </button>
          </dt>
          <dd class="layer-cnt_ty1">
            <div class="layer-tit">저장용량 세부정보</div>
            <ul>
              <li class="clear">
                <div class="fl">전체 저장용량</div>
                <div class="fr"><b>10GB</b> <span>(100%)</span></div>
              </li>
              <li class="clear">
                <div class="fl">내가 생성한 업무보드</div>
                <div class="fr"><b>0GB</b> <span>(0%)</span></div>
              </li>
              <li class="clear">
                <div class="fl">내부이관 전용 폴더</div>
                <div class="fr"><b>0GB</b> <span>(0%)</span></div>
              </li>
            </ul>
            <div class="info">
              * 외부망에서 내부이관 전용 폴더로 이관된 보드는 최대 15일 보관 후
              서버 용량 관리를 위해 자동 삭제됩니다.
            </div>
          </dd>
        </dl>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";

export default {
  components: {},
  props: ["groupInfo"],
  created() {},
  data() {
    return {};
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    ...mapActions("modals", ["showModal"]),

    /* 보드 만들기 모달 호출 */
    addBoard() {
      this.$emit("addPrivateBoard");
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/mypage/private/base/PrivateHeader.vue